<div class="grid mb-3">
	<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
		<p-tag icon="pi cm-alert" [value]="('NOTE_EDIT_PERMISSIONS_MTM' | translate)" severity="warning"></p-tag>
		<p-button styleClass="border-0" icon="pi cm-quick-easy" size="large" label="{{ 'GO_TO' | translate }}: {{ 'PERMISSIONS' | translate }}"
			(click)="goToPermissionVoiceMenu()" [rounded]="false" [text]="true" severity="secondary">
		</p-button>
	</div>
	<div *ngIf="underMinFwVerKeypads()" class="col-12 flex align-items-center justify-content-center bg-red-200 p-1 border-round-xl">
		<i class="pi cm-alert pl-3 text-red-700"></i>
		<p-tag [value]="('WARNING_QE_MIN_FW_VER_MTM_KEYPADS_NOT_SUPPORTED' | translate)" severity="danger"></p-tag>
	</div>
	<div *ngIf="underMinFwVerTags()" class="col-12 flex align-items-center justify-content-center bg-red-200 p-1 border-round-xl">
		<i class="pi cm-alert pl-3 text-red-700"></i>
		<p-tag [value]="('WARNING_QE_MIN_FW_VER_MTM_TAGS_NOT_SUPPORTED' | translate)" severity="danger"></p-tag>
	</div>
	<div class="col-12">
		<p-table #tableDtmfList dataKey="Id" [value]="mtmaPermissions" [lazy]="true" (onLazyLoad)="loadTags($event)"
			[paginator]="true" [totalRecords]="totalRecords" [loading]="permissionLoading" [rows]="pageSize"
			[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true"
			responsiveLayout="stack" sortField="End" [sortOrder]="-1">
			<ng-template pTemplate="caption">
				<div class="grid">
					<div [class]="actionLayout('left')">
					</div>
					<div [class]="actionLayout('center')">
						<div class="flex flex-column justify-content-center gap-2">
							<span class="flex align-items-center justify-content-center">
								<i class="pi cm-memory-storage mr-1"></i>
								{{ 'MEMORY_USAGE' | translate }}: {{memorySize}} / {{maxMemorySize}}
							</span>
							<p-progressBar [value]="getValueMemory()">
								<ng-template pTemplate="content" let-value>
									<span *ngIf="getValueMemory() > 4">{{getValueMemory()}} %</span>
								</ng-template>
							</p-progressBar>
						</div>
					</div>
					<div [class]="actionLayout('right')">
						<span class="p-input-icon-left" [class]="dynamicInputSearchWidth()">
							<i class="pi cm-search"></i>
							<input [formControl]="searchFilter" pInputText type="text" id="customers-input-search"
								placeholder="{{ 'SEARCH' | translate }}" [ngClass]="dynamicInputSearchWidth()" maxlength="60" />
						</span>
					</div>
				</div>
			</ng-template>
			<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
				<tr>
					<th style="width: 5rem"></th>
					<th>
						<div pSortableColumn="Name" class="flex align-items-center justify-content-center">
							{{ 'NAME' | translate }}
							<p-sortIcon field="Name"></p-sortIcon>
						</div>
					</th>
					<th>
						<div pSortableColumn="Email" class="flex align-items-center justify-content-center">
							{{ 'EMAIL' | translate }}
							<p-sortIcon field="Email"></p-sortIcon>
						</div>
					</th>
					<th>
						<div pSortableColumn="Start" class="flex align-items-center justify-content-center">
							{{ 'START_DATE' | translate }}
							<p-sortIcon field="Start"></p-sortIcon>
						</div>
					</th>
					<th>
						<div pSortableColumn="End" class="flex align-items-center justify-content-center">
							{{ 'END_DATE' | translate }}
							<p-sortIcon field="End"></p-sortIcon>
						</div>
					</th>
					<th>
						<div class="flex align-items-center justify-content-center">
							{{ 'RADIOCOMANDO_KEYBOARD' | translate }}
						</div>
					</th>
					<th>
						<div class="flex align-items-center justify-content-center">
							{{ 'SINGLE_RFID_CARD' | translate }}
						</div>
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-permission let-expanded="expanded">
				<tr>
					<td>
						<p-button
							styleClass="surface-900 hover:bg-primary border-1 border-600" [pRowToggler]="permission" [rounded]="true"
							[icon]="expanded ? 'pi cm-angle-down' : 'pi cm-angle-right'" />
					</td>
					<td>
						<span class="p-column-title font-semibold">{{ 'NAME' | translate }}</span>
						<div class="flex align-items-center justify-content-center">{{ permission.Name | truncate:[30] }}</div>
					</td>
					<td>
						<span class="p-column-title font-semibold">{{ 'EMAIL' | translate }}</span>
						<div class="flex align-items-center justify-content-center">{{ permission.Email }}</div>
					</td>
					<td>
						<span class="p-column-title font-semibold">{{ 'START_DATE' | translate }}</span>
						<div class="flex align-items-center justify-content-center">{{ permission.Start | localizedDate: 'medium' }}</div>
					</td>
					<td>
						<span class="p-column-title font-semibold">{{ 'END_DATE' | translate }}</span>
						<div class="flex align-items-center justify-content-center">{{ permission.End | localizedDate: 'medium' }}</div>
					</td>
					<td>
						<span class="p-column-title font-semibold">{{ 'RADIOCOMANDO_KEYBOARD' | translate }}</span>
						<div class="flex flex-row justify-content-center gap-2">
							<p-tag [value]="permission.SendPincodeMtma ? ('ENABLE' | translate) : ('DISABLED' | translate) "
								[severity]="permission.SendPincodeMtma ? 'success' : 'danger'">
							</p-tag>
						</div>
					</td>
					<td>
						<span class="p-column-title font-semibold">{{ 'SINGLE_RFID_CARD' | translate }}</span>
						<div class="flex flex-row justify-content-center gap-2">
							<p-tag [value]="permission.SendRfidMtma ? ('ENABLE' | translate) : ('DISABLED' | translate) "
								[severity]="permission.SendRfidMtma ? 'success' : 'danger'">
							</p-tag>
						</div>
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="emptymessage">
				<tr>
					<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="rowexpansion" let-mainpermission>
				<tr class="surface-400">
					<td colspan="7">
						<div class="w-full" [class]="onExtendedMobile() ? 'px-2' : 'px-6'">
							<p-table [value]="[mainpermission]" [paginator]="false" [showCurrentPageReport]="true"
								currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true"
								responsiveLayout="stack">
								<ng-template pTemplate="header">
									<tr>
										<th>
											<div class="flex align-items-center justify-content-center">
												{{ 'ACTION1' | translate }}
											</div>
										</th>
										<th>
											<div class="flex align-items-center justify-content-center">
												{{ 'ACTION2' | translate }}
											</div>
										</th>
										<th>
											<div class="flex align-items-center justify-content-center">
												{{ 'RADIOCOMANDO_KEYBOARD' | translate }}
											</div>
										</th>
										<th>
											<div class="flex align-items-center justify-content-center">
												{{ 'SINGLE_RFID_CARD' | translate }}
											</div>
										</th>
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-item>
									<tr>
										<td>
											<span class="p-column-title font-semibold">{{ 'ACTION1' | translate }}</span>
											{{ (item.Commands[0] && item.Commands[0].CommandDescription) ? item.Commands[0].CommandDescription : '' }}
										</td>
										<td>
											<span class="p-column-title font-semibold">{{ 'ACTION2' | translate }}</span>
											{{ (item.Commands[1] && item.Commands[1].CommandDescription) ? item.Commands[1].CommandDescription : '' }}
										</td>
										<td>
											<span class="p-column-title font-semibold">{{ 'RADIOCOMANDO_KEYBOARD' | translate }}</span>
											{{ item.PinCode }}
										</td>
										<td>
											<span class="p-column-title font-semibold">{{ 'SINGLE_RFID_CARD' | translate }}</span>
											{{ item.RfidQeCode }}
										</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td colspan="7" [class]="underTablet() ? 'flex justify-content-center' : ''">{{ 'TABLE_NO_ELEMENT' |
											translate }}</td>
									</tr>
								</ng-template>
							</p-table>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>